let scrollOptions = {
    rootMargin: '15%',
    threshold: 0.1,
    animateClassName: 'sal-animate',
    disabledClassName: 'sal-disabled',
    enterEventName: 'sal:in',
    exitEventName: 'sal:out',
    selector: '[data-sal]',
    once: true,
    disabled: false
};

let elements = [];
let intersectionObserver = null;

const setOptions = (settings) => {
    if (settings && settings !== scrollOptions) {
      scrollOptions = {
        ...scrollOptions,
        ...settings,
      };
    }
};

const clearAnimation = (element) => {
    element.classList.remove(scrollOptions.animateClassName);
};

const fireEvent = (name, entry) => {
    const event = new CustomEvent(name, {bubbles: true, detail: entry,});
    entry.target.dispatchEvent(event);
};

const animate = (entry) => {
    entry.target.classList.add(scrollOptions.animateClassName);
    fireEvent(scrollOptions.enterEventName, entry);
};

const reverse = (entry) => {
    clearAnimation(entry.target);
    fireEvent(scrollOptions.exitEventName, entry);
};

const isAnimated = (element) => (
    element.classList.contains(scrollOptions.animateClassName)
);

const enableAnimations = () => {
    document.body.classList.remove(scrollOptions.disabledClassName);
    document.body.classList.add('anim');
};

const disableAnimations = () => {
    document.body.classList.add(scrollOptions.disabledClassName);
};

const clearObserver = () => {
    intersectionObserver.disconnect();
    intersectionObserver = null;
    largeIntersectionObserver.disconnect();
    largeIntersectionObserver = null;
};


const onIntersection = (entries, observer) => {
    entries.forEach((entry) => {
      const { target } = entry;
      const hasRepeatFlag = target.dataset.salRepeat !== undefined;
      const hasOnceFlag = target.dataset.salOnce !== undefined;
      const shouldRepeat = hasRepeatFlag || !(hasOnceFlag || scrollOptions.once);

      if (entry.intersectionRatio >= observer.thresholds[0]) {
            animate(entry);
            if (!shouldRepeat) {
            observer.unobserve(target);
            }
        } else if (shouldRepeat) {
            reverse(entry);
        }
    });
};

const disable = () => {
    disableAnimations();
    clearObserver();
};

const enable = () => {
    enableAnimations();
    const windowHeight = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);

    intersectionObserver = new IntersectionObserver(onIntersection, {
      rootMargin: scrollOptions.rootMargin,
      threshold: scrollOptions.threshold,
    });

    largeIntersectionObserver = new IntersectionObserver(onIntersection, {
        rootMargin: '200px',
        threshold: 0.3
    });

    elements = [].filter.call(
      document.querySelectorAll(scrollOptions.selector),
      (element) => !isAnimated(element, scrollOptions.animateClassName),
    );

    setTimeout(function() {
        elements.forEach((element) => {
            let elHeight = element.offsetHeight;
            if(elHeight > (windowHeight / 2)) {
                largeIntersectionObserver.observe(element);
            } else {
                intersectionObserver.observe(element)
            }
        });

    }, 100, elements)
  };

/**
 * Reset instance and provide new settings
 * @param {Object} settings
 */
const reset = (settings = {}) => {
    clearObserver();

    Array.from(document.querySelectorAll(scrollOptions.selector))
      .forEach(clearAnimation);

    setOptions(settings);
    enable();
};

const init = (settings = scrollOptions) => {
    setOptions(settings);

    if (typeof window === 'undefined') {
      return {elements, disable, enable, reset};
    }

    if (!window.IntersectionObserver) {
      disableAnimations();
      throw Error(NOT_SUPPORTED_MESSAGE);
    }

    enable();

    return {elements, disable, enable, reset};
};

window.addEventListener("load", (event) => {
    setUpScrollEvents();
    setTimeout(function() {
        init();
    }, 200);
});

function setUpScrollEvents()
{
    const slideRightElements = document.querySelectorAll('.wp-block-str-left-column > *');
    const slideUpElements = document.querySelectorAll('.wp-block-str-vertical-card, .wp-block-str-right-column p, .wp-block-str-right-column .wp-block-heading');
    const fadeInElements = document.querySelectorAll('footer .wp-block-group, .has-background, .wp-block-str-colour-header .wp-block-str-column, .team-member');
    const slideUpStaggerredParents = [['.wp-block-str-horizontal-cards', '.wp-block-str-horizontal-card'], ['.wp-block-accordion', '.wp-block-accordion-heading'], ['.is-layout-grid', '.wp-block-group'], ['.wp-block-str-info-cards', '.wp-block-str-info-card'], ['.list', 'article a'], ['main ul', 'li']];

    const fadeInStaggeredParents = [['.wp-block-str-media-grid', 'figure'], ['.wp-block-social-links', 'a'], ['.wp-block-str-page-header', '*'], ['.case-study-header', '*']]

    fadeInElements.forEach(element => {
        element.setAttribute('data-sal', 'fade');
        element.setAttribute('data-sal-duration', '500');
        element.setAttribute('data-sal-delay', '250');
    })
    slideUpElements.forEach(element => {
        element.setAttribute('data-sal', 'slide-up');
        element.setAttribute('data-sal-duration', '900');
        element.setAttribute('data-sal-delay', '250');
    });
    slideRightElements.forEach(element => {
        element.setAttribute('data-sal', 'slide-right');
        element.setAttribute('data-sal-duration', '900');
        element.setAttribute('data-sal-delay', '300');
    });

     slideUpStaggerredParents.forEach((p) => {
        let items = document.querySelectorAll(p[0]);
        items.forEach((i) => {
            let children = i.querySelectorAll(p[1]);
            children.forEach((e, i) => {
                var delay = 300 + (i * 150);
                e.setAttribute('data-sal-duration', '700');
                e.style.transitionDelay = (delay / 1000) + 's';
                e.setAttribute('data-sal', 'slide-up');
            })
        })
    })
     fadeInStaggeredParents.forEach((p) => {
        let items = document.querySelectorAll(p[0]);
        items.forEach((i) => {
            let children = i.querySelectorAll(p[1]);
            children.forEach((e, i) => {
                var delay = 300 + (i * 150);
                e.setAttribute('data-sal-duration', '700');
                e.style.transitionDelay = (delay / 1000) + 's';
                e.setAttribute('data-sal', 'fade');
            })
        })
    })
}